import React, { useContext, useEffect, useState } from 'react'
import WrapperTextPage from '../../../modules/WrapperTextPage/WrapperTextPage'
import { useParams } from 'react-router-dom'
import { parseUrl } from '../../../function/parseUrl'
import { getRequest } from '../../../request/request'
import { errors } from '../../../function/errors'
import { Title, WrapperData } from '../../../style/style'
import { Text } from '../../../modules/WrapperTextPage/style/WrapperTextPageStyle'
import moment from 'moment/moment'
import { DateNews } from '../../../modules/News/style/NewsStyle'
import { formatDate } from '../../../function/formatDate'
import { ContextType } from '../../../type/type'
import { AppContext } from '../../../App'

const PageSearchItem = () => {
  const { id } = useParams()
  const { state } = useContext<ContextType>(AppContext)
  const [data, setData] = useState<any>(null)
  const [urlVersion, setUrlVersion] = useState<any>(null)
  const [formatData, setFormatData] = useState<string>('DD.MM.YYYY')

  useEffect(() => {
    setFormatData(formatDate(state.lang))
    const request = JSON.parse(parseUrl('?', 'request'))
    setUrlVersion(request)

    if (!request) {
      getRequest(`/news/${id}/`)
        .then((res) => {
          setData(res?.data)
        })
        .catch((err) => errors(err))
    }
  }, [state.lang])

  return id ? (
    <WrapperData className="br-12">
      {urlVersion ? (
        <WrapperTextPage id={id} />
      ) : (
        data && (
          <>
            <DateNews className="date">
              {data?.date_creation && moment(data?.date_creation).format(formatData)}
            </DateNews>
            <Title>{data.title}</Title>
            <Text dangerouslySetInnerHTML={{ __html: data?.text }} />
          </>
        )
      )}
    </WrapperData>
  ) : null
}

export default PageSearchItem
